import React, { useEffect, useState } from 'react';
import SweetAlertModal from '../../../components/SweetAlertModal/SweetAlertModal';
import Cancel from './../../../../assets/icons/close.png';
import itemImg from './../../../../assets/icons/menu.png';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import { ToastContainer, toast } from 'react-toastify'
import FoodItemUnlinkModal from '../Unlink/FoodItemUnlinkModal.tsx';


import axios from 'axios';

import {
  Button,
  Grid,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';

function FoodItemArchiveDialog(props) {
  console.log(props);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] =useState(false);
  const [openArchiveConfirmaitonModal, setopenArchiveConfirmaitonModal] =useState(false);
  const [openDeleteConfirmaitonModal, setopenDeleteConfirmaitonModal] =useState(false);
  const [openUnlinkConfirmaitonModal, setopenUnlinkConfirmaitonModal] =useState(false);
  const [openUnlinkModal, setopenUnlinkModal] =useState(false);
  const [selectedValue, setSelectedValue] = useState<any>(null);
  const [dataRows, setDataRows] = useState([]);

  const [selectedDataRows, setSelectedDatarows] = React.useState([]);

  const getselectedData = (props) => {
    console.log(props);
    setSelectedDatarows(props);
  };


  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRowId(null);
  };

  const { open, onClose, dialogType,ActiveItem,cancledRes,cancleMenus,linkdata, onToggleSwitch ,selectedRestaurants,openDialog: toggle, linkedFoodItems,Status} = props;

  console.log(ActiveItem);
  console.log(cancledRes);
  console.log(Status);

const apiAddress = process.env.REACT_APP_SECRET;

  const [restaurantId, setRestaurantId] = useState([]);

  const handleClose = () => {
    props.onClose()
    //props.onHandleAddItem(restaurantId);
    // setKeyword(null)
    setSelectedValue(null);
    setopenMenuCloseConfirmaitonModal(false);
    setopenArchiveConfirmaitonModal(false);
    setOpenDialog(false);
    setRestaurantId([]);
    
  };

  useEffect(() => {
    if(Status=="Single Archive"){
      if (cancledRes && cancledRes.length > 0) {
        let count=0
        count++
        console.log(count)
        let canceledObjs=[]
        let canceledObj={}
        cancledRes.forEach((dt) => {
          canceledObj={
            restaurantId: dt.linkedRestaurantId,
            menuId: dt.linkedMenuId,
            sectionId : dt.linkedSectionId,
            foodItem : dt.linkedFoodItemId,
            activeFoodItemId : null
  
          }
          canceledObjs.push(canceledObj)
        });
  
        console.log(canceledObjs)
  
        var url = apiAddress + '/api/FoodItems/allfooditemarchiveinfo';
    
        axios.post(url, canceledObjs).then((response) => {
          console.log(response.data);
    
          var list = [];
          response.data.forEach((dt, i) => {
            var obj = {
              id: i,
              restaurantName: dt.restaurantName,
              menuName: dt.menuName,
              sectionName: dt.sectionName,
              foodName: dt.foodName,
              linkedFoodName: dt.linkedFoodName
            };
            list.push(obj);
          });
          console.log(list);
          setDataRows(list);
        }).catch((error) => {
          console.error('Error occurred:', error.response.data);
        });
      }
    }
    else if(Status=="Bulk Archive"){
      if (cancledRes && cancledRes.length > 0) {
        let count=0
        count++
        console.log(count)
        let canceledObjs=[]
        let canceledObj={}
        cancledRes.forEach((dt) => {
          canceledObj={
            restaurantId: dt.linkedRestaurantId,
            menuId: dt.linkedMenuId,
            sectionId : dt.linkedSectionId,
            foodItem : dt.linkedFoodItemId,
            activeFoodItemId : dt.activeFoodItem
  
          }
          canceledObjs.push(canceledObj)
        });
  
        console.log(canceledObjs)
  
        var url = apiAddress + '/api/FoodItems/allfooditemarchiveinfo';
    
        axios.post(url, canceledObjs).then((response) => {
          console.log(response.data);
    
          var list = [];
          response.data.forEach((dt, i) => {
            var obj = {
              id: i,
              restaurantName: dt.restaurantName,
              menuName: dt.menuName,
              sectionName: dt.sectionName,
              foodName: dt.foodName,
              linkedFoodName: dt.linkedFoodName
            };
            list.push(obj);
          });
          console.log(list);
          setDataRows(list);
        }).catch((error) => {
          console.error('Error occurred:', error.response.data);
        });
      }
    }
  }, [cancledRes]);

  const archiveSubmit = () => {
    if(Status=="Single Archive"){

      if (cancledRes && cancledRes.length > 0) {

        let canceledObjs=[]
        let canceledObj={}
        cancledRes.forEach((dt) => {
          canceledObj={
            restaurantId: dt.linkedRestaurantId,
            menuId: dt.linkedMenuId,
            sectionId : dt.linkedSectionId,
            foodItem : dt.linkedFoodItemId
          }
          canceledObjs.push(canceledObj)
          console.log(canceledObjs);
        });
  
  
        var url = apiAddress + '/api/FoodItems/foodItemarchived'; 
  
          axios.put(url, canceledObjs).then((response) => {
            console.log(response.data);
            toast.success("FoodItem Succesfully Archived", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
          });
          console.log(canceledObjs)
          props.onHandleAddItem(canceledObjs);
          setSelectedValue(null);
          setopenMenuCloseConfirmaitonModal(false);
          setopenArchiveConfirmaitonModal(false);
          setOpenDialog(false);
          //setRestaurantId([]);
          //cancledRes=[];
      });
    }
  }
  else if(Status=="Bulk Archive"){
    if (cancledRes && cancledRes.length > 0) {

      let canceledObjs=[]
      let canceledObj={}
      cancledRes.forEach((dt) => {
        canceledObj={
          restaurantId: dt.linkedRestaurantId,
          menuId: dt.linkedMenuId,
          sectionId : dt.linkedSectionId,
          foodItem : dt.linkedFoodItemId,
          activeFoodItemId : dt.activeFoodItem
        }
        canceledObjs.push(canceledObj)
        console.log(canceledObjs);
      });


      var url = apiAddress + '/api/FoodItems/foodItemBulkarchived'; 

        axios.put(url, canceledObjs).then((response) => {
          console.log(response.data);
          toast.success("FoodItem Succesfully Archived", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
        console.log(canceledObjs)
        props.onHandleAddItem(canceledObjs);
        setSelectedValue(null);
        setopenMenuCloseConfirmaitonModal(false);
        setopenArchiveConfirmaitonModal(false);
        setOpenDialog(false);
        //setRestaurantId([]);
        //cancledRes=[];
    });
    }
  }
}

const unlinkSubmit = () => {

  if(Status=="Bulk Archive"){
    if (cancledRes && cancledRes.length > 0) {

      let canceledObjs=[]
      let canceledObj={}
      cancledRes.forEach((dt) => {
        canceledObj={
          restaurantId: dt.linkedRestaurantId,
          menuId: dt.linkedMenuId,
          sectionId : dt.linkedSectionId,
          foodItem : dt.linkedFoodItemId,
          activeFoodItemId : dt.activeFoodItem
        }
        canceledObjs.push(canceledObj)
        console.log(canceledObjs);
      });
      var url = apiAddress + '/api/FoodItems/foodItemUnlinkFromSection'; 
  
        axios.put(url, canceledObjs).then((response) => {
          console.log(response.data);
          toast.success("FoodItem Succesfully Unlinked", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
        props.onHandleAddItem(canceledObjs);
        setSelectedValue(null);
        setopenMenuCloseConfirmaitonModal(false);
        setopenUnlinkConfirmaitonModal(false);
        setOpenDialog(false);
        //setRestaurantId([]);
        //cancledRes=[];
    });
  }
  }
}

const deleteSubmit = () => {

  if(Status=="Single Archive"){
    if (cancledRes && cancledRes.length > 0) {
      let deletefoodItemIds=[]

      cancledRes.forEach((dt) => {
        deletefoodItemIds.push(dt.linkedFoodItemId)    
      });
      console.log(deletefoodItemIds);

      var url = apiAddress + '/api/FoodItems/DeleteFoodItem'; 

        axios.put(url, deletefoodItemIds).then((response) => {
          console.log(response.data);
          toast.success("FoodItem Succesfully Deleted", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
        //props.onHandleAddItem(canceledObjs);
        setSelectedValue(null);
        setopenMenuCloseConfirmaitonModal(false);
        setopenArchiveConfirmaitonModal(false);
        setOpenDialog(false);
        //setRestaurantId([]);
        //cancledRes=[];
      });
    }
  }
  else if(Status=="Bulk Archive"){
    if (cancledRes && cancledRes.length > 0) {

      let canceledObjs=[]
      let canceledObj={}
      cancledRes.forEach((dt) => {
        canceledObj={
          restaurantId: dt.linkedRestaurantId,
          menuId: dt.linkedMenuId,
          sectionId : dt.linkedSectionId,
          foodItem : dt.linkedFoodItemId,
          activeFoodItemId : dt.activeFoodItem
        }
        canceledObjs.push(canceledObj)
        console.log(canceledObjs);
      });


      var url = apiAddress + '/api/FoodItems/foodItemBulkDelete'; 

        axios.put(url, canceledObjs).then((response) => {
          console.log(response.data);
          toast.success("FoodItem Succesfully Deleted", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
        console.log(canceledObjs)
        props.onHandleAddItem(canceledObjs);
        setSelectedValue(null);
        setopenMenuCloseConfirmaitonModal(false);
        setopenDeleteConfirmaitonModal(false);
        setOpenDialog(false);
        //setRestaurantId([]);
        //cancledRes=[];
    });
    }
  }
  }

  const handleUnlink = () => {
    
    if(Status=="Single Archive"){
      setopenUnlinkModal(true)
    }
    else if(Status=="Bulk Archive"){
      setopenUnlinkConfirmaitonModal(true)
    }

  }

  const handleunlinkModalClose = () => {
    setopenUnlinkModal(false)
    props.onClose();
  }


  return (
    <div>
      <React.Fragment>
        <Dialog
          maxWidth={'md'}
          open={props.open}
          onClose={handleClose}
        >
          <SweetAlertModal
            headerText={'Do you want to leave without saving?'}
            bodyText={'All changes made will be lost'}
            open={openMenuCloseConfirmaitonModal}
            onyes={handleClose}
            close={() => {
              setopenMenuCloseConfirmaitonModal(false);
            }}
            id={2}
          />
            <SweetAlertModal
            headerText={'Are you sure?'}
            bodyText={'Do you want to Delete this foodItem?'}
            open={openDeleteConfirmaitonModal}
            onyes={deleteSubmit}
            close={() => {
              setopenDeleteConfirmaitonModal(false);
            }}
          />
            <SweetAlertModal
            headerText={'Are you sure?'}
            bodyText={
              <>
                All These Food Item's will be unlinked from <strong>{ActiveItem?.itemName}</strong>
              </>
            }
            open={openUnlinkConfirmaitonModal }
            onyes={unlinkSubmit}
            close={() => {
              setopenUnlinkConfirmaitonModal(false);
            }}
          />

            <SweetAlertModal
            headerText={'Are you sure?'}
            bodyText={'Do you want to Archive this foodItem?'}
            open={openArchiveConfirmaitonModal}
            onyes={archiveSubmit}
            close={() => {
              setopenArchiveConfirmaitonModal(false);
            }}    
          />
          <Grid container>
            <Grid item xs={9}>
              <DialogTitle>
                <div className='d-flex' style={{ gap: '8px' }}>
                  <div>
                    <img src={itemImg} style={{ width: '1.8rem' }} alt='' />
                  </div>

                  <span style={{ color: '#2a7fd4' }}>
                    GoTaste :- {dialogType}
                  </span>
                </div>
              </DialogTitle>
            </Grid>
            <Grid item xs={3}>
              <DialogActions>
                <Button onClick={() => setopenMenuCloseConfirmaitonModal(true)}>
                  <img src={Cancel} alt='Close' style={{ width: '1.2rem' }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent>
            {/* {dataRows.map((dt,i)=>(
            <span>
            <p>This menu {dt.menuName} will be disabled For these Restaurant's</p>
          </span>
            ))} */}
            {
              dataRows.length > 0 && Status=="Single Archive" && (
                <span>
                  <p>
                     
                  <b>{`{${dataRows.map(row => row.foodName).join(', ')}}`}</b> in <b>{`{${dataRows.map(row => row.sectionName).join(', ')}}`}</b> will be removed from the restaurant/menus below
                  </p>
                </span>
              )
            }
            {
              dataRows.length > 0 && Status=="Bulk Archive" && (
                <span>
                  <p>
                    {dataRows.length === 1 ? (
                      <>
                        <b>{`{${dataRows.length}}`}</b> food item and related item in <b>{`{${dataRows.length}}`}</b> section will be removed from the restaurant/menus below
                      </>
                    ) : (
                      <>
                        <b>{`{${dataRows.length}}`}</b> food items and related items in <b>{`{${dataRows.length}}`}</b> sections will be removed from the restaurant/menus below
                      </>
                    )}
                  </p>
                </span>
              )
            }

            {/* <CustomDataGrid columns={columns} dataRows={dataRows}/> */}
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align='center'>Restaurant Name</TableCell>
                  <TableCell align='center'>Related Menu</TableCell>
                  <TableCell align='center'>Related Section</TableCell>
                  {Status == "Bulk Archive" && (
                  <TableCell align='center'>Related Items</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {dataRows.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align='center'>{row.restaurantName}</TableCell>
                    <TableCell align='center'>{row.menuName}</TableCell>
                    <TableCell align='center'>{row.sectionName}</TableCell>
                    {Status == "Bulk Archive" && row?.linkedFoodName !==null && (
                    <TableCell align='center'>{row.foodName+','+ row.linkedFoodName}</TableCell>
                    )}
                    {Status == "Bulk Archive" && row?.linkedFoodName ==null && (
                    <TableCell align='center'>{row.foodName}</TableCell>
                    )}
                    
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions>
          <Button
            onClick={() => setopenArchiveConfirmaitonModal(true) }
            color='error'
            >
            Archive
            </Button>
            <Button
            onClick={() => setopenDeleteConfirmaitonModal(true) }
            color='error'
            >
            Delete
            </Button>
            {linkdata?.length > 0 && (
                <Button
                  onClick={handleUnlink}
                  color="error"
                >
                  Unlink Item
                </Button>
              )
            }
            <Button
                onClick={() => setopenMenuCloseConfirmaitonModal(true)}
                color='primary'
            >
                Close
            </Button>
            </DialogActions>
        </Dialog>
      </React.Fragment>
      {openUnlinkModal && (
      <FoodItemUnlinkModal 
        open={openUnlinkModal}
        dialogType={'Food Item Unlink'}
        onClose={handleunlinkModalClose}
        linkedFooditem={cancledRes}
      />
      )}
    </div>
    
  );
}

export default FoodItemArchiveDialog;
